import { CartContentType } from "@/shared/utils/enum";
import { formatPrice } from "@/shared/utils/helpers";
import { CartContent } from "@/shared/v2/queries/interfacesV2";
import { renderToStaticMarkup } from "react-dom/server";
import Center from "../Base/Center";
import Icon from "../Icon/Icon";
import Tooltip from "@/Components/Tooltip/Tooltip";

const ClientDiscountContent = ({
  cartContent,
}: {
  cartContent: CartContent[];
}) => {
  return (
    <Tooltip
      content={
        <div
          dangerouslySetInnerHTML={{
            __html: renderToStaticMarkup(
              <ul style={{ padding: "1rem", margin: 0 }}>
                {cartContent
                  ?.filter(
                    (c) =>
                      c.type === CartContentType.DISCOUNT_VALUE ||
                      c.type === CartContentType.LOYALTY_POINTS_SPENDAGE
                  )
                  .map((discount) => (
                    <li key={discount.name}>
                      {discount.name}{" "}
                      {formatPrice(discount.single_price_inc_vat)}
                    </li>
                  ))}
              </ul>
            ),
          }}
        />
      }
    >
      <div>
        <Center>
          <Icon className="h-8 w-8 fill-text" variants="info" />
        </Center>
      </div>
    </Tooltip>
  );
};

export default ClientDiscountContent;
